import Ebony7Attic1 from "../Ebony/Ebony 7 Attic.png"
import Ebony7Attic2 from "../Ebony/Ebony 7 Attic.png"

const Ebony7Atticimages =[
    Ebony7Attic1,Ebony7Attic2
]

export default Ebony7Atticimages;